var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-cell-group',[_c('van-cell',{attrs:{"title":"我的打卡","is-link":""},on:{"click":_vm.goToDaka}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }